import React from 'react'

/* eslint-disable functional/immutable-data */
/* eslint-disable functional/prefer-readonly-type */

export function mapActionType(
  translate: (item: string) => string,
  requestType?: { readonly type?: 'CREATE' | 'EDIT' | 'DELETE' | string }
): string {
  const raw = String(requestType?.type || '').toUpperCase()

  if (raw === 'CREATE' || raw === 'POST') return translate('CREATE')
  if (raw === 'PUT' || raw === 'UPDATE') return translate('EDIT')
  if (raw === 'DELETE' || raw === 'REMOVED') return translate('DELETE')

  return raw ? raw : ''
}

export function buildReportTypeOptions(translate: (item: string) => string) {
  return [
    { value: 'create', label: translate('CREATE') },
    { value: 'edit', label: translate('EDIT') },
    { value: 'delete', label: translate('DELETE') },
  ]
}

export const formatPermissionsGrouped = (permissions: Array<{ description: string }>) => {
  const crudGroups: Record<string, string[]> = {
    'Pode criar:': [],
    'Pode visualizar:': [],
    'Pode editar:': [],
    'Pode remover:': [],
  }

  permissions.forEach((perm) => {
    let desc = perm.description.replace(/^Pode\s+/, '')
    
    // Remove prefixos específicos
    desc = desc.replace(/^(criar|adicionar|visualizar|listar|acessar|imprimir|editar|deletar|remover)\s+/i, '')

    if (perm.description.includes('criar') || perm.description.includes('adicionar')) {
      crudGroups['Pode criar:'].push(desc)
    } else if (perm.description.includes('visualizar') || perm.description.includes('listar') || perm.description.includes('acessar') || perm.description.includes('imprimir')) {
      crudGroups['Pode visualizar:'].push(desc)
    } else if (perm.description.includes('editar')) {
      crudGroups['Pode editar:'].push(desc)
    } else if (perm.description.includes('deletar') || perm.description.includes('remover')) {
      crudGroups['Pode remover:'].push(desc)
    }
  })

  return crudGroups
}
